// AudioEventDeduplicator — prevents a one-time cue from replaying for the same authoritative
// event across refresh, background-resume, reconnect, and navigation. Keys are derived from
// safe server identifiers only. Backed by localStorage with bounded FIFO storage.
const LS_KEY = "ff_audio_cue_dedup";
const MAX = 200;

function _read() {
  try { return JSON.parse(localStorage.getItem(LS_KEY)) || []; } catch (e) { return []; }
}
function _write(arr) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(arr.slice(-MAX))); } catch (e) { /* quota */ }
}

// Stable key: session id + event type + outcome/version. No PII, no narrative.
export function cueKey(evt) {
  const parts = [
    evt.type,
    evt.session_id || evt.sessionId || "-",
    evt.outcome || evt.tier || evt.rank || evt.achievement_id || evt.season_id || "-",
    evt.version != null ? String(evt.version) : "-",
  ];
  return parts.join("|");
}

export class AudioEventDeduplicator {
  constructor() { this.mem = new Set(_read()); }
  has(key) { return this.mem.has(key); }
  add(key) {
    if (this.mem.has(key)) return false;
    this.mem.add(key);
    const arr = _read();
    arr.push(key);
    _write(arr);
    // keep in-memory bounded too
    if (this.mem.size > MAX) this.mem = new Set(_read().slice(-MAX));
    return true;
  }
  size() { return this.mem.size; }
  clear() { this.mem = new Set(); _write([]); }
}

export default AudioEventDeduplicator;
